import Button from "@mui/material/Button";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";

import { PublicSvgIcon } from "~/components/public_svg_icon";

interface KycSubmittedProps {
  onBack: () => void;
}

export function KycSubmitted({ onBack }: KycSubmittedProps) {
  return (
    <Stack
      data-testid="kyc-submitted"
      sx={{ alignItems: "center", gap: 10, color: "gray.800" }}
    >
      <PublicSvgIcon name="document_search" />
      <Stack sx={{ alignItems: "center", gap: 2.5 }}>
        <Typography
          variant="h3"
          component="h1"
          sx={{ fontWeight: 700, letterSpacing: "0.24px", textAlign: "center" }}
        >
          Details submitted
        </Typography>
        <Typography variant="h6" component="p">
          Your information has been successfully submitted. You will be notified
          if any further information is required. You will now be redirected
          back to the Trustap Dashboard.
        </Typography>
      </Stack>
      <Button
        variant="contained"
        size="large"
        disableElevation
        onClick={onBack}
        data-testid="kyc-submitted-back-button"
        sx={{ fontSize: 16, lineHeight: "26px", letterSpacing: "0.46px" }}
      >
        Back to Trustap dashboard
      </Button>
    </Stack>
  );
}
